import { Controller } from "@hotwired/stimulus"

// 옵션이 있는 키오스크 상품을 담을 때 뜨는 선택 모달 전용 컨트롤러.
// #modals 프레임은 kiosk 컨트롤러(주문 목록/결제 버튼)의 DOM 범위 밖이라 직접 fetch로
// 처리하고, 응답 헤더(X-Kiosk-Cart)는 kiosk:cart-updated 이벤트로 브로드캐스트해서
// kiosk_controller.js가 결제 버튼/수량 표시를 갱신하도록 한다.
export default class extends Controller {
  static values = {
    url:       String,
    posItemId: String,
    basePrice: Number
  }

  static targets = ["totalPrice"]

  connect() {
    this.recalculate()
  }

  recalculate() {
    const checked = [...this.element.querySelectorAll("[data-option-choice]:checked")]
    const optionTotal = checked.reduce((sum, el) => sum + (parseInt(el.dataset.priceDelta) || 0), 0)
    const total = this.basePriceValue + optionTotal
    if (this.hasTotalPriceTarget) {
      this.totalPriceTarget.textContent = total.toLocaleString("ko-KR") + "원"
    }
  }

  async add(event) {
    event.preventDefault()

    const allGroupIds = [...new Set(
      [...this.element.querySelectorAll("[data-option-choice]")].map(el => el.dataset.groupId)
    )]
    const checked = [...this.element.querySelectorAll("[data-option-choice]:checked")]
    const checkedGroupIds = checked.map(el => el.dataset.groupId)
    const missing = allGroupIds.filter(id => !checkedGroupIds.includes(id))
    if (missing.length > 0) {
      alert("옵션을 선택해주세요.")
      return
    }

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new URLSearchParams()
    body.append("pos_item_id", this.posItemIdValue)
    checked.forEach(el => {
      body.append("selections[][group_id]", el.dataset.groupId)
      body.append("selections[][choice_id]", el.value)
    })

    try {
      const response = await fetch(this.urlValue, {
        method:  "POST",
        headers: {
          "X-CSRF-Token": csrf,
          "Accept":       "text/vnd.turbo-stream.html"
        },
        body
      })

      if (!response.ok) return

      const html = await response.text()
      window.Turbo.renderStreamMessage(html)

      const cartHeader = response.headers.get("X-Kiosk-Cart")
      if (cartHeader) {
        window.dispatchEvent(new CustomEvent("kiosk:cart-updated", { detail: JSON.parse(cartHeader) }))
      }

      window.dispatchEvent(new CustomEvent("modals:close"))
    } catch (e) {
      console.error("Kiosk option add failed:", e)
    }
  }
}
